<agpr-take-over-panel
    class="agpr-compressedNav"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close()"
    [showFooter]="false"
    [width]="35"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <nav class="agpr-compressedNav-content">
        <h2 class="u-srOnly">{{ (menuItems.length > 1 ? 'Core.navigation' : 'Core.navigation.other') | localize }}</h2>
        <agpr-scroll-panel>
            <ng-container *ngFor="let section of menuItems; let i = index">
                <ul
                    class="agpr-compressedNav-section"
                    [attr.aria-label]="(i === 0 ? 'Core.navigation.main' : 'Core.navigation.other') | localize"
                >
                    <li *ngFor="let mainItem of section" class="agpr-compressedNav-mainItem" [ngClass]="{'agpr-compressedNav-mainItem--expanded': !mainItem.collapsed}">
                        <ng-container *ngTemplateOutlet="mainItem.items ? groupItem : navItem; context: {item: mainItem}"></ng-container>
                    </li>
                </ul>
                <div class="agpr-compressedNav-separator"></div>
            </ng-container>
            <div class="agpr-compressedNav-section">
                <div class="agpr-compressedNav-accounts-label">{{ 'Core.navigation.account.workingAs' | localize }}</div>
                @if (originalAccounts.length > 5){
                    <div class="agpr-compressedNav-searchContainer">
                        <agpr-text-input
                            class="agpr-accounts-search"
                            icon="fa-regular fa-duotone fa-magnifying-glass"
                            [placeholder]="'Core.navigation.account.search'"
                            [bottomMargin]="false"
                            [(ngModel)]="searchTerm"
                            (ngModelChange)="filterAccounts()"
                            [autocomplete]="'off'"
                            [iconDecorative]="true"
                        ></agpr-text-input>
                    </div>
                }

                @if (userAccounts.length === 0 ) {
                    <agpr-message
                        [severity]="messageSeverity.noContent"
                    >
                        {{ 'Core.navigation.account.notFound' | localize }}
                    </agpr-message>
                }
                <ul
                    class="agpr-compressedNav-accounts"
                    [attr.aria-label]="'Core.navigation.accounts' | localize"
                >
                    <li
                        *ngFor="let account of userAccounts"
                        class="agpr-compressedNav-subMenu-item"
                    >
                        <button
                            class="agpr-compressedNav-navItem agpr-compressedNav-navItem--noSubLabel"
                            [ngClass]="{
                                'selected': account.id === userState.account.id,
                                'disabled-account': !account.active || account.isExpiryDatePast
                            }"
                            [attr.tabindex]="!account.active || account.isExpiryDatePast ? -1 : 0"
                            (click)="(account.active && !account.isExpiryDatePast && (account.id !== userState.account.id)) ? switchAccount(account) : false"
                        >
                            <div class="agpr-compressedNav-activeBar"></div>
                            <span class="agpr-account-label">
                                {{account.name}} {{ (!account.active || account.isExpiryDatePast) ? ('Core.navigation.account.inactive' | localize) : '' }}
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
        </agpr-scroll-panel>
    </nav>
</agpr-take-over-panel>
<ng-template #groupItem let-item="item" let-class="class">
    <button
        class="agpr-compressedNav-group"
        (click)="toggleNavItem(item)"
        [attr.aria-expanded]="!item.collapsed"
        [attr.aria-label]="item.ariaLabel | localize"
    >
        <div class="agpr-compressedNav-activeBar" [ngClass]="{'agpr-compressedNav-activeBar--selected': item.selected}"></div>
        <div class="agpr-compressedNav-group-dropdown">
            @if (!!item.icon && item.id !== 'primaryNavSupport') {
                <span [class]="item.icon" class="agpr-compressedNav-navItem-icon"></span>
            }
            <span
                class="agpr-compressedNav-group-label"
                [ngClass]="{'agpr-compressedNav-subMenu-iconLabel-subLabel-link': item.id === 'primaryNavContentManagement' || item.id === 'primaryNavQuotaUsageDashboards'}"
            >{{item.label | localize}}</span>
        </div>
        <span
            class="agpr-compressedNav-group-toggleIcon fa-duotone fa-regular"
            [ngClass]="item.collapsed ? 'fa-angle-down' : 'fa-angle-up'"
            aria-hidden="true"
        ></span>
    </button>
    @if (item.items) {
        <ul
            class="agpr-compressedNav-subMenu"
            [ngClass]="{'agpr-compressedNav-subMenu--spaced': item.id === 'primaryNavAccounts' || item.id === 'primaryNavSupport' || item.id === 'primaryNavAdmin'}"
            [style]="item.collapsed ? '' : 'display: block;'"
            [@subMenuContent]="item.collapsed ? 'hidden' : 'visible'"
            (@subMenuContent.done)="animationDone($event)"
            [attr.aria-label]="item.label | localize"
        >
            @if (item.showUpsell) {
                <div
                    class="agpr-upsell"
                >
                    <div class="agpr-upsell-content">
                        <div class="agpr-upsell-header">
                            <span class="agpr-upsell-header-icon fa-regular fa-duotone fa-lock"></span>
                            {{ item.label | localize }}
                        </div>
                        <div class="agpr-upsell-message">{{ item.upsellMessage | localize }}</div>
                        <button
                            class="agpr-upsell-button"
                            (click)="openUpsellInfoPanel(item)"
                        >
                            {{'Core.navigation.unlock' | localize}}
                        </button>
                    </div>
                </div>
            } @else {
                @for (subItem of item.items; track subItem.id) {
                    <li
                        class="agpr-compressedNav-subMenu-item"
                        [ngClass]="{'disabled': subItem.disabledTooltip || subItem.showUpsell}"
                    >
                        @if (subItem.disabledTooltip || subItem.showUpsell) {
                            <div class="disabledBanner">
                                <span class="fa-solid fa-lock disabledBannerIcon"></span>
                            </div>
                        }
                        <ng-container
                            *ngTemplateOutlet="subItem.items ? groupItem : navItem; context: {item: subItem}"
                        ></ng-container>
                    </li>
                }
            }
        </ul>
    }

</ng-template>

<ng-template #navItem let-item="item">
    @if (!!item.routerLink && !item.showUpsell) {
        <a
            class="agpr-compressedNav-navItem"
            [ngClass]="{'agpr-compressedNav-navItem--noSubLabel': !item.subLabel}"
            [routerLink]="item.disabledTooltip ? '' : item.routerLink"
            [agprTooltip]="item.disabledTooltip | localize"
        >
            <ng-container *ngTemplateOutlet="navItemLabel; context: {$implicit: item}"></ng-container>
        </a>
    }
    @if (!!item.routerLink && item.showUpsell) {
        <button
            class="agpr-compressedNav-navItem"
            [ngClass]="{'agpr-compressedNav-navItem--noSubLabel': !item.subLabel}"
            (click)="openSubItemUpsell(item, $event)"
            attr.aria-haspopup="dialog"
            [attr.aria-label]="item.label | localize"
        >
            <ng-container *ngTemplateOutlet="navItemLabel; context: {$implicit: item}"></ng-container>
        </button>
    }
    @if (!!item.url) {
        <a
            class="agpr-compressedNav-navItem"
            [ngClass]="{'agpr-compressedNav-navItem--noSubLabel': !item.subLabel}"
            [href]="item.url"
            target="{{ item.target ? item.target : '_blank'}}"
        >
            <ng-container *ngTemplateOutlet="navItemLabel; context: {$implicit: item}"></ng-container>
        </a>
    }
    @if (item.type === navTypes.dialog) {
        <button
            class="agpr-compressedNav-navItem"
            [ngClass]="{'agpr-compressedNav-navItem--noSubLabel': !item.subLabel}"
            (click)="openDialog(item.dialogReference)"
            attr.aria-haspopup="dialog"
            [agprTooltip]="'Core.navigation.contentManagement.openInPanelTooltip' | localize"
            tooltipPosition="left"
            [useTooltipAsAriaLabel]="false"
            [attr.aria-label]="item.label | localize"
            [attr.aria-describedby]="item.id + '_description'"
        >
            <ng-container *ngTemplateOutlet="navItemLabel; context: {$implicit: item}"></ng-container>
        </button>
    }
    @if (item.type === navTypes.takeOverPanel) {
        <button
            class="agpr-compressedNav-navItem"
            [ngClass]="{'agpr-compressedNav-navItem--noSubLabel': !item.subLabel}"
            (click)="openTakeOverPanel(item.dialogReference)"
            attr.aria-haspopup="dialog"
            [agprTooltip]="'Core.navigation.contentManagement.openInPanelTooltip' | localize"
            tooltipPosition="left"
            [useTooltipAsAriaLabel]="false"
            [attr.aria-label]="item.label | localize"
            [attr.aria-describedby]="item.id + '_description'"
        >
            <ng-container *ngTemplateOutlet="navItemLabel; context: {$implicit: item}"></ng-container>
        </button>
    }
    @if (item.type === navTypes.contactSupport) {
        <button
            class="agpr-compressedNav-navItem"
            [ngClass]="{'agpr-compressedNav-navItem--noSubLabel': !item.subLabel}"
            (click)="openIntercom()"
        >
            <ng-container *ngTemplateOutlet="navItemLabel; context: {$implicit: item}"></ng-container>
        </button>
    }

</ng-template>

<ng-template #navItemLabel let-item>
    <div class="agpr-compressedNav-navItem-header">
        <div class="agpr-compressedNav-activeBar" [ngClass]="{'agpr-compressedNav-activeBar--selected': item.selected}"></div>
        @if (!!item.icon) {
            <span [class]="item.icon" class="agpr-compressedNav-navItem-icon"></span>
        }
        <span class="agpr-compressedNav-navItem-label">{{item.label | localize}}</span>
        @if (item.type === navTypes.takeOverPanel || item.type === navTypes.dialog) {
            <span>
                <span [id]="item.id + '_description'" class="u-srOnly">{{ 'Core.navigation.contentManagement.openInPanelTooltip' | localize }}</span>
                <span class="fa-solid fa-window-restore agpr-compressedNav-navItem-dialogIcon"></span>
            </span>
        }
    </div>
    @if (!!item.subLabel) {
        <div class="agpr-compressedNav-navItem-subLabel"> {{ item.subLabel | localize }}</div>
    }

</ng-template>
